import {defineProvider} from '@nuxt/image/runtime'

// Maps @nuxt/image modifier keys → IPX v3 modifier keys
const KEY_MAP: Record<string, string> = {
  width: 'w',
  height: 'h',
  format: 'f',
  quality: 'q',
  fit: 'fit',
  blur: 'blur',
  sharpen: 'sharpen',
  grayscale: 'grayscale',
  rotate: 'rotate',
}
/**
 * baseURL is only meant for local usage, in production the app is on the same domain as the backend
 */
export default defineProvider<{baseURL?: string}>({
  getImage(src, options) {
    const config = useRuntimeConfig()
    const baseURL = import.meta.dev ? options.baseURL?.replace('/api', '') : config.public.baseUrl || location.origin

    // src is a full absolute CMS URL: "http://cms:3000/api/media/file.jpg"
    // Strip /api/media to get just "/file.jpg"
    const filePath = new URL(src).pathname.replace(/^\/api\/media\/file/, '')

    const ops =
      Object.entries(options.modifiers ?? {})
        .filter(([, v]) => v !== undefined && v !== '')
        .map(([k, v]) => {
          const key = KEY_MAP[k] ?? k
          return `${key}_${v}`
        })
        .join(',') || '_'

    const url = new URL(`/api/ipx/${ops}${filePath}`, baseURL).toString()

    return {url}
  },
})
